<script type="text/ecmascript-6">
    export default {
        data: function () {
            return {
                baseUrl: Scoop.baseUrl,
                combineOpened: false
            }
        },

        computed: {
            attributeValuesSelected: {
                get: function () {
                    return scoopOS.getSelected('attributeValues');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('attributeValues', newValue);
                }
            },
            count() {
                return this.attributeValuesSelected.length;
            }
        },

        methods: {
            deselect() {
                scoopOS.deselectAll('attributeValues');
            }
        }
    }
</script>
<template>
    <li id="selected-attributeValues-widget" v-if="count > 0" class="dropdown">

        <portal to="modals">
            <combine-correct-attribute-values
                    :attribute-value-ids="attributeValuesSelected"
                    :is-open="combineOpened"
                    @close="combineOpened = false">
            </combine-correct-attribute-values>
        </portal>

        <a class="dropdown-toggle count-info"
           data-toggle="dropdown"
           href="#"
           aria-expanded="true"
        >
            <i class="fa fa-list"></i> <span class="label label-primary" v-text="count"></span>
        </a>
        <ul class="dropdown-menu dropdown-alerts">
            <li class="dropdown-header">
                <h4 v-text="__('scoop-os.attributes.combine-values.menu-headline')"></h4>
            </li>
            <li>
                <a @click="combineOpened = true">
                    <div>
                        <i class="fa fa-compress fa-fw"></i>
                        <span v-text="__('scoop-os.attributes.combine-values.headline')"></span>
                    </div>
                </a>
            </li>
            <li class="divider"></li>
            <li>
                <a @click="deselect">
                    <div>
                        <i class="fa fa-eraser fa-fw"></i>
                        <span v-text="__('scoop-os.attributes.combine-values.deselect')"></span>
                    </div>
                </a>
            </li>
        </ul>
    </li>
</template>